﻿define([
    'jquery',
    'pubsub',
    'generalUtilities',
    'moduleUtilities',
    'moment',
    'userSearchGridCompiled',
    'connectionUtilities',
    'agentsSearchUtilities',
    'languageSpokenData',
    'messageControl2',
    'trackPhoneNumberUtilities'
], function userSearchGridControl(
    $,
    pubsub,
    generalUtilities,
    moduleUtilities,
    moment,
    userSearchGridCompiled,
    connectionUtilities,
    agentsSearchUtilities,
    languageSpokenGeneralData
) {
    // set up
    // -------------------------------------------

    'use strict';

    var module, selectors, elements, values, userSearchRendered, languagesList;

    module = {};
    module.private = {};
    module.properties = {};

    selectors = {};
    selectors.searchPage = '.js-usersearch-page';
    selectors.gridWrapper = '.js-usersearch-grid';
    selectors.expandPremiumDetailsButton = '.js-agenttile-expander';
    selectors.collapsePremiumDetailsButton = '.js-agenttile-collapse';
    selectors.agentTileMinimal = '.re-agenttile-minimal.re-agenttile-minimal-clickable';

    elements = {};

    values = {};

    userSearchRendered = false;

    languagesList = languageSpokenGeneralData.browse();

    // utilities
    // -------------------------------------------

    module.private.initElements = function initElements() {
        elements.body = $('body');
        elements.searchPage = $(selectors.searchPage);
        elements.gridWrapper = $(selectors.gridWrapper);
        return elements;
    };

    module.private.findLanguageByCode = function findLanguageByCode(code) {
        var iter;
        for (iter = 0; iter < languagesList.length; ++iter) {
            if (languagesList[iter].value.indexOf(code) !== -1) {
                return languagesList[iter].label;
            }
        }
        return code;
    };

    module.private.massageData = function massageData(data) {
        var i, l, it, resultList;
        var countryCode = generalUtilities.prop(RESAAS, 'User2.CountryId');
        var isAuthenticated = generalUtilities.prop(RESAAS, 'User2.UserId');
        var isCommercialExperience = generalUtilities.prop(RESAAS, 'Environment.Experience') === 'commercial';

        resultList = [];
        resultList.push.apply(resultList, data);

        for (i = 0, l = resultList.length; i < l; i++) {
            resultList[i].prettyCreationDate = moment(resultList[i].CreationDate).format('Y');
            resultList[i].connectionInfo = connectionUtilities.getConnectionInfo(resultList[i].UserId);

            if (resultList[i].Domain) {
                resultList[i].userListingsLink = resultList[i].Domain.replace('/profile', '/listings');
                resultList[i].sendReferralLink = resultList[i].Domain.replace('/profile', '/referral');
                resultList[i].userMentioned = generalUtilities.stringFormat('@{0}', resultList[i].Domain.split('/')[0]);
            }

            resultList[i].viewerAuthenticated = generalUtilities.prop(RESAAS, 'User2.UserId');

            resultList[i].isCommercial = isCommercialExperience;
            resultList[i].isFeatured = resultList[i].isCommercial || resultList[i].IsPremiumPlus;

            if (resultList[i].Phone) {
                resultList[i].phoneNumber = resultList[i].Phone;
            } else if (resultList[i].OfficePhone) {
                resultList[i].phoneNumber = resultList[i].OfficePhone;
            }

            resultList[i].showAddress =
                resultList[i].City || resultList[i].Province || resultList[i].Address || resultList[i].Country;

            // only show country if different from the users or the user is anonymous
            resultList[i].showCountry =
                resultList[i].CountryCode && (!isAuthenticated || resultList[i].CountryCode != countryCode);

            resultList[i].showCountryComma =
                resultList[i].showCountry && (resultList[i].City || resultList[i].Province || resultList[i].Address);

            resultList[i].FirmOrOffice = resultList[i].Firm || resultList[i].OfficeName;

            // only show counts if they are greater than 0
            if (resultList[i].ListingActiveCount) {
                resultList[i].activeListingText = generalUtilities.stringFormat(
                    RESAAS.Localization.UserSearch.AGENT_TILE_ACTIVE_LISTINGS,
                    resultList[i].ListingActiveCount
                );
            }
            if (resultList[i].ListingSoldCount) {
                resultList[i].soldListingText = generalUtilities.stringFormat(
                    RESAAS.Localization.UserSearch.AGENT_TILE_SOLD_LISTINGS,
                    resultList[i].ListingSoldCount
                );
            }
            if (resultList[i].ListingComingSoonCount) {
                resultList[i].ListingComingSoonCountText = generalUtilities.stringFormat(
                    RESAAS.Localization.UserSearch.AGENT_TILE_PREMARKET_LISTINGS,
                    resultList[i].ListingComingSoonCount
                );
            }

            if (
                resultList[i].ListingActiveCount ||
                resultList[i].ListingSoldCount ||
                resultList[i].ListingComingSoonCount
            ) {
                resultList[i].hasStats = true;
            }

            if (resultList[i].AwardedReferrals) {
                resultList[i].AwardedReferralsStr = resultList[i].AwardedReferrals > 1 ? generalUtilities.stringFormat(
                    RESAAS.Localization.UserSearch.USER_SEARCH_AWARDED_REFERRALS,
                    resultList[i].AwardedReferrals
                ) : generalUtilities.stringFormat(
                    RESAAS.Localization.UserSearch.USER_SEARCH_AWARDED_REFERRAL,
                    resultList[i].AwardedReferrals
                );
            }

            if (resultList[i].NetworkSize) {
                resultList[i].NetworkSizeStr = resultList[i].NetworkSize > 1 ? generalUtilities.stringFormat(
                    RESAAS.Localization.UserSearch.USER_SEARCH_NETWORK_SIZES,
                    resultList[i].NetworkSize
                ) : generalUtilities.stringFormat(
                    RESAAS.Localization.UserSearch.USER_SEARCH_NETWORK_SIZE,
                    resultList[i].NetworkSize
                );
            }

            // copy enhanced profile up a level
            if (resultList[i].EnhancedProfile) {
                resultList[i].LicenseNumber = resultList[i].EnhancedProfile.LicenseNumber;
                resultList[i].StartedIn = resultList[i].EnhancedProfile.StartedIn;
                if (resultList[i].EnhancedProfile.StartedIn) {
                    resultList[i].YearsExp =
                        new Date().getFullYear() - parseInt(resultList[i].EnhancedProfile.StartedIn, 10);
                    if (resultList[i].YearsExp > 1) {
                        resultList[i].YearsExpStr = generalUtilities.stringFormat(
                            RESAAS.Localization.UserSearch.USER_SEARCH_YEARS_EXP,
                            resultList[i].YearsExp
                        );
                    } else {
                        resultList[i].YearsExpStr = "1 Year of Experience";
                    }
                }
                resultList[i].AreasOfExpertise = resultList[i].EnhancedProfile.AreasOfExpertise;
                resultList[i].Awards = resultList[i].EnhancedProfile.Awards;
                resultList[i].Credentials = resultList[i].EnhancedProfile.Credentials;
                resultList[i].Languages = resultList[i].EnhancedProfile.Languages;
                resultList[i].FacebookUrl = resultList[i].EnhancedProfile.FacebookUrl;
                resultList[i].LinkedInUrl = resultList[i].EnhancedProfile.LinkedInUrl;
                resultList[i].TwitterUrl = resultList[i].EnhancedProfile.TwitterUrl;
                resultList[i].InstagramUrl = resultList[i].EnhancedProfile.InstagramUrl;
                resultList[i].LogoUrl = resultList[i].EnhancedProfile.LogoUrl;
            }

            // transform languages list to english
            if (resultList[i].Languages) {
                for (it = 0; it < resultList[i].Languages.length; ++it) {
                    resultList[i].Languages[it] = module.private.findLanguageByCode(resultList[i].Languages[it]);
                }
            }

            // professional agents can only send direct referrals
            resultList[i].showReferralButton = !generalUtilities.prop(RESAAS, 'User2.IsPendingProfessional');
        }

        

        return resultList;
    };

    module.private.injectNonUserItems = function injectNonUserItems(data, user, env) {
        var isCommercialExperience = generalUtilities.prop(env, 'Experience') === 'commercial';
        var isRemax = generalUtilities.prop(env, 'Experience') === 'remax';
        var isPremiumPlus = generalUtilities.prop(user, 'PremiumPlus');
        var isAuthenticated = generalUtilities.prop(user, 'UserId');

        var firstNotFeatured, firstFeatured;
        var featuredTitle, agentsTitle, upsellCTA;

        var resultList = [];
        resultList.push.apply(resultList, data);

        if (resultList.length && !isCommercialExperience && !isRemax) {
            upsellCTA = { upsellCTA: true };
            featuredTitle = { featuredTitle: true };
            agentsTitle = { agentTitle: true };

            // add featured title
            firstFeatured = resultList.findIndex(function findIndexTest(i) {
                return i.isFeatured;
            });

            if (firstFeatured >= 0) {
                resultList.unshift(featuredTitle);
            }

            // add agents title
            firstNotFeatured = resultList.findIndex(function findIndexTest(i) {
                return i.isFeatured === false;
            });

            if (firstNotFeatured >= 0) {
                resultList.splice(firstNotFeatured, 0, agentsTitle);
            }

            // add upsellCTA
            firstFeatured = resultList.findIndex(function findIndexTest(i) {
                return i.isFeatured;
            });

            if (isAuthenticated && !isPremiumPlus) {
                upsellCTA.featuredAgentName = generalUtilities.prop(resultList[firstFeatured], 'Firstname');
                upsellCTA.Firstname = generalUtilities.prop(user, 'FirstName');
                upsellCTA.Lastname = generalUtilities.prop(user, 'LastName');
                upsellCTA.City = generalUtilities.prop(user, 'City');
                upsellCTA.Province = generalUtilities.prop(user, 'State');
                // cannot get OfficeName from profile in User2 yet, needs a BE ticket
                // upsellCTA.OFficeName generalUtilities.prop('RESAAS', 'User2.PorfileOfficeName')
                upsellCTA.Firm = generalUtilities.prop(user, 'FirmName');
                upsellCTA.FirmOrOffice = !!upsellCTA.Firm; // || upsellCTA.OfficeName;
                upsellCTA.showAddress = !!upsellCTA.City || !!upsellCTA.Province;
                upsellCTA.noClick = true;
                resultList.splice(firstFeatured + 1, 0, upsellCTA);
            }
        }

        return resultList;
    };

    module.private.setupStartingTile = function setupStartingTile(arr) {
        var addImageTile = { starterTile: true };
        arr.unshift(addImageTile);
    };

    module.private.chooseTemplate = function chooseTemplate(data) {
        var template;

        template = {
            userSearchGridExternal: false,
            userSearchGridInternal: false,
            userSearchGridGeneric: false
        };

        if (generalUtilities.prop(RESAAS, 'User2.IsProfessional')) {
            if (
                (data.request.FirmId && data.request.ExcludeFirmId) === true ||
                (data.request.GroupId && data.request.ExcludeGroupId)
            ) {
                template.userSearchGridExternal = true;
            } else if (data.request.FirmId || data.request.GroupId) {
                template.userSearchGridInternal = true;
            } else {
                template.userSearchGridGeneric = true;
            }
        } else {
            template.userSearchGridGeneric = true;
        }

        return template;
    };

    // event handlers
    // -------------------------------------------
    module.private.handleConnectionPromise = function handleConnectionPromise() {
        connectionUtilities.getConnectionPromise().then(function getConnectionPromiseThen() {
            if (userSearchRendered) {
                module.private.handleUserSearchBrowseSuccess(values.userSearch);
            }
        });
    };
    module.private.handleUserSearchBrowseSuccess = function handleUserSearchBrowseSuccess(data) {
        var newData, action, remainingUsers;

        newData = Object.assign({}, data);
        action = newData.intent === 'search' ? 'html' : 'append';
        remainingUsers = agentsSearchUtilities.private.rowItemRemainder(newData);

        if (remainingUsers > 0) {
            newData.response.Data.splice(newData.response.Data.length - remainingUsers, remainingUsers);
        }

        newData.template = module.private.chooseTemplate(newData);

        newData.response.Data = module.private.massageData(newData.response.Data); 

        if (newData.template.userSearchGridGeneric && action === 'html') {
            newData.response.Data = module.private.injectNonUserItems(newData.response.Data, generalUtilities.prop(window, 'RESAAS.User2'), generalUtilities.prop(window, 'RESAAS.Environment'));
        }

        values.userSearch = newData;

        if (newData.template.userSearchGridInternal) {
            if (data.intent === 'search' && data.padding === 1) {
                module.private.setupStartingTile(newData.response.Data);
            }
        }

        newData.noConnections = newData.response.Count === 0 && data.request.RelationshipSearch === '2';
        newData.FirmAgent = generalUtilities.prop(RESAAS, 'User2.FirmName')
            ? generalUtilities.stringFormat(
                  RESAAS.Localization.UserSearch.STARTING_BUILDING_NETWORK_FIRM_AGENTS,
                  generalUtilities.prop(RESAAS, 'User2.FirmName')
              )
            : false;
        newData.noAgents = newData.response.Count === 0 && data.request.RelationshipSearch !== '2';

        elements.gridWrapper[action](userSearchGridCompiled(newData));
        userSearchRendered = true;
    };

    module.private.handleUserSearchBrowseError = function handleUserSearchBrowseError(data) {
        elements.gridWrapper.children().remove();
        pubsub.publish('uiAction.MessageAdd', {
            message: RESAAS.Localization.UserSearch.USER_SEARCH_ERROR_RESULTS,
            type: 'error'
        });
        pubsub.publish('loggly.error', { message: 'User search failed: ' + JSON.stringify(data) });
    };

    module.private.handleDataUserSearchBrowse = function handleDataUserSearchBrowse(e, data) {
        if (data && data.request && !data.request.SkipCount) {
            agentsSearchUtilities.trackInMixpanel(data);
        }

        if (moduleUtilities.isOwnEvent(data, module.properties)) {
            elements.gridWrapper.removeClass('re-usersearch-submitting');
            if (data && data.response && data.response.Success) {
                module.private.handleUserSearchBrowseSuccess(data);
                // error
            } else {
                module.private.handleUserSearchBrowseError(data);
            }
        }
    };

    module.private.handleUiNeedsUserSearchBrowse = function handleUiNeedsUserSearchBrowse(e, data) {
        if (moduleUtilities.isOwnEvent(data, module.properties)) {
            elements.gridWrapper.addClass('re-usersearch-submitting');
        }
    };

    module.private.handleExpandPremiumDetails = function handleExpandPremiumDetails(e) {
        $(e.currentTarget.parentElement).removeClass('collapse');
        $(e.currentTarget.parentElement).addClass('expand');
        e.currentTarget.nextElementSibling.style.maxHeight = generalUtilities.stringFormat(
            '{0}px',
            e.currentTarget.nextElementSibling.scrollHeight + 100
        );

        setTimeout(function wait() {
            if (document.body.contains(e.currentTarget)) {
                e.currentTarget.nextElementSibling.style = '';
            }
        }, 1000);
    };

    module.private.handleCollapsePremiumDetails = function handleExpandCollapseDetails(e) {
        var tertiaryContent = e.currentTarget.parentElement.parentElement.parentElement.parentElement;
        $(tertiaryContent.parentElement).addClass('collapse');
        $(tertiaryContent.parentElement).removeClass('expand');
        tertiaryContent.style.maxHeight = generalUtilities.stringFormat('{0}px', tertiaryContent.scrollHeight + 100);
        setTimeout(function wait() {
            if (document.body.contains(e.currentTarget)) {
                tertiaryContent.style.maxHeight = '0px';
            }
        }, 100);
    };

    module.private.handleAgentTileMinimalClick = function handleAgentTileMinimalClick(e) {
        e.preventDefault();
        generalUtilities.redirect($(e.currentTarget).find('.re-agenttile-profilelink').attr('href'));
    };

    module.private.init = function init(e, data) {
        // set values
        module.properties.guid = data && data.guid ? data.guid : generalUtilities.uuid();

        generalUtilities.configureMoment(moment);

        // set cachable elements
        module.private.initElements();
        module.private.handleConnectionPromise();

        // click handlers
        elements.body.on('click', selectors.expandPremiumDetailsButton, module.private.handleExpandPremiumDetails);
        elements.body.on('click', selectors.collapsePremiumDetailsButton, module.private.handleCollapsePremiumDetails);
        elements.body.on('click', selectors.agentTileMinimal, module.private.handleAgentTileMinimalClick);
    };

    // external event bindings
    //-------------------------------------------

    pubsub.subscribe('uiWantsUserSearchGridControlInit', module.private.init);
    pubsub.subscribe('uiNeedsUserSearchBrowse', module.private.handleUiNeedsUserSearchBrowse);
    pubsub.subscribe('dataUserSearchBrowse', module.private.handleDataUserSearchBrowse);

    // expose API
    //-------------------------------------------
    return module;
});
